import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { deleteAllToastId } from '../../actions/ToastActions';
import { deleteNotify } from '../action';
/**
 * reducerに保持されているtoastを、unmount時に非表示にするuse
 * （主にautoClose: falseで表示されっぱなしになってしまうtoastを制御する）
 * @param dispatch
 */
export const useToastUnmountClear = (dispatch) => {
    const toastIds = useSelector((state) => state.toast.toastIds);
    const toastRef = useRef([]);
    toastRef.current = toastIds;
    useEffect(() => () => {
        toastRef.current.forEach((v) => {
            deleteNotify(v);
        });
        dispatch(deleteAllToastId());
    }, [dispatch, toastRef]);
};
export default useToastUnmountClear;
